
import { useState } from 'react';
import { lacados, type Lacado } from '../../data/lacados';

export default function LacadosSection() {
  const [imagenAmpliada, setImagenAmpliada] = useState<Lacado | null>(null);

  const abrirImagenAmpliada = (lacado: Lacado) => {
    setImagenAmpliada(lacado);
    document.body.style.overflow = 'hidden';
  };

  const cerrarImagenAmpliada = () => {
    setImagenAmpliada(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <>
      {/* Lacados Section */}
      <div className="bg-white rounded-lg overflow-hidden" style={{ marginBottom: 'clamp(3rem, 5vh, 6rem)' }}>
        {/* Section Header */}
        <div className="relative">
          <div 
            className="bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center"
            style={{ aspectRatio: '3/2' }}
          >
            <img
              src="/images/lacado_hero.webp" 
              alt="Muebles de baño con acabados lacados de calidad premium"
              className="w-full h-full object-cover opacity-80"
            />
            <div className="absolute inset-0 bg-[#191a19] bg-opacity-40 flex items-center justify-center">
              <div className="text-center text-white" style={{ padding: '0 clamp(1rem, 2vw, 3rem)' }}>
                <h2 
                  className="font-light text-white" 
                  style={{ 
                    fontFamily: 'Playfair Display, serif',
                    fontSize: 'clamp(2rem, 4vw, 5rem)',
                    marginBottom: 'clamp(0.5rem, 1vh, 2rem)'
                  }}
                >
                  LACADOS
                </h2>
              </div>
            </div>
          </div>
        </div>

        {/* Lacados Grid */}
        <div style={{ padding: 'clamp(1rem, 2vw, 3rem)' }}>
          <div className="border-b border-gray-200" style={{ padding: 'clamp(1rem, 1.5vw, 2rem) 0' }}>
            <div className="flex items-center space-x-2 text-gray-700">
              <span 
                className="font-medium" 
                style={{ 
                  fontFamily: 'Playfair Display, serif',
                  fontSize: 'clamp(1rem, 1.5vw, 1.5rem)'
                }}
              >
                Lacados disponibles
              </span>
            </div>
          </div>

          <div 
            className="grid"
            style={{ 
              gridTemplateColumns: 'repeat(auto-fit, minmax(clamp(120px, 15vw, 200px), 1fr))',
              gap: 'clamp(1rem, 2vw, 2rem)',
              padding: 'clamp(1rem, 2vh, 3rem) 0'
            }}
          >
            {/* El RAL/NCS a medida se ofrece en el configurador, no en la carta de color. */}
            {lacados.filter((l) => !l.aMedida).map((lacado) => (
              <div 
                key={lacado.id} 
                className="group cursor-pointer"
                onClick={() => abrirImagenAmpliada(lacado)}
              >
                <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden" style={{ marginBottom: 'clamp(0.5rem, 1vh, 1rem)' }}>
                  <img
                    src={lacado.imagen}
                    alt={`Muebles de baño lacado ${lacado.nombre} - Navamuel`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="text-center">
                  <h3 
                    className="font-medium text-gray-900" 
                    style={{ 
                      fontFamily: 'Playfair Display, serif',
                      fontSize: 'clamp(0.75rem, 1vw, 1rem)',
                      marginBottom: 'clamp(0.125rem, 0.25vh, 0.5rem)'
                    }}
                  >
                    {lacado.nombre}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal de Imagen Ampliada */}
      {imagenAmpliada && (
        <div className="fixed inset-0 bg-[#191a19]/80 z-50 flex items-center justify-center" style={{ padding: 'clamp(1rem, 2vw, 2rem)' }}>
          <div 
            className="relative w-full bg-white rounded-lg overflow-hidden"
            style={{ 
              maxWidth: 'clamp(300px, 80vw, 1200px)',
              maxHeight: '90vh'
            }}
          >
            <button
              onClick={cerrarImagenAmpliada}
              className="absolute z-10 bg-white/90 hover:bg-white rounded-full flex items-center justify-center cursor-pointer transition-colors"
              style={{
                top: 'clamp(0.5rem, 1vw, 1rem)',
                right: 'clamp(0.5rem, 1vw, 1rem)',
                width: 'clamp(2rem, 3vw, 2.5rem)',
                height: 'clamp(2rem, 3vw, 2.5rem)'
              }}
            >
              <i className="ri-close-line text-gray-800" style={{ fontSize: 'clamp(1rem, 1.5vw, 1.25rem)' }}></i>
            </button>
            
            <div style={{ padding: 'clamp(1rem, 2vw, 2rem)' }}>
              <div className="grid grid-cols-1 lg:grid-cols-2" style={{ gap: 'clamp(1rem, 3vw, 3rem)' }}>
                <div className="aspect-square overflow-hidden rounded-lg shadow-2xl ring-1 ring-black/10">
                  <img
                    src={imagenAmpliada.imagen}
                    alt={`Muebles de baño lacado ${imagenAmpliada.nombre} - Detalle`}
                    className="w-full h-full object-cover"
                  />
                </div>
                
                <div className="flex flex-col justify-center items-center">
                  <h2 
                    className="font-light text-gray-900" 
                    style={{ 
                      fontFamily: 'Playfair Display, serif',
                      fontSize: 'clamp(1.5rem, 3vw, 4rem)',
                      marginBottom: 'clamp(0.5rem, 1vh, 2rem)'
                    }}
                  >
                    {imagenAmpliada.nombre}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
